import React, { useCallback, useEffect, useMemo, useState } from 'react';
import MapMultiple from '../../../../Components/General/Map/MapMultiple';
import { getInformationRegisterSMAList } from '../../../../helpers/data_providers/backend_helper';
import { useMantineTheme } from '@mantine/core';

const MapEstablishmentList = ({
	title,
	zoom = 4,
	selectedEstablishmentSiep,
	onSelectEstablishment,
}) => {
	const mantineTheme = useMantineTheme();

	const handleMarkerClick = useCallback(establishment => {
		onSelectEstablishment(establishment);
	}, [onSelectEstablishment]);

	// Custom marker function to handle colors based on establishment state
	const customMarker = useCallback((point, markerElement, isSelected) => {
		let backgroundColor = mantineTheme.colors.gray[5]; // Default gray color
		let title = 'Estado desconocido';

		// Set color based on establishment state
		switch (point.state) {
			case 'verde':
				backgroundColor = mantineTheme.colors.green[5]; // Green
				title = 'Verde (Sin Incidentes)';
				break;
			case 'amarillo':
				backgroundColor = mantineTheme.colors.yellow[5]; // Yellow
				title = 'Amarillo (< 1 día)';
				break;
			case 'rojo':
				backgroundColor = mantineTheme.colors.red[5]; // Red
				title = 'Rojo (>= 1 día)';
				break;
			default:
				// Keep default values
				break;
		}

		// Apply styles to marker
		markerElement.style.backgroundColor = backgroundColor;
		markerElement.title = title;

		// If selected, add a border or different styling
		if (isSelected) {
			let color = mantineTheme.colors.blue[5];

			switch (point.state) {
				case 'verde':
					color = mantineTheme.colors.green[7];
					break;
				case 'amarillo':
					color = mantineTheme.colors.yellow[7];
					break;
				case 'rojo':
					color = mantineTheme.colors.red[7];
					break;
				default:
					break;
			}

			markerElement.style.border = `3px solid ${color}`;
			markerElement.style.borderRadius = '50%';
		}
	}, [mantineTheme.colors]);

	const [establishments, setEstablishments] = useState([]);

	useEffect(() => {
		getInformationRegisterSMAList({
			locations: true,
		}).then(response => {
			setEstablishments(response.data);
		});
	}, []);

	const pointsData = useMemo(() => {
		return establishments.map((establishment, index) => ({
			id: establishment._id || index + 1,
			latitude: establishment.latitude || null,
			longitude: establishment.longitude || null,
			name: establishment.nombre_centro || '',
			code_siep: establishment.siep_code || 'Sin código SIEP',
			state: establishment.state,
			originalEstablishment: establishment,
		}));
	}, [establishments]);

	useEffect(() => {
		if (pointsData.length === 0 || selectedEstablishmentSiep) return;

		const firstValid = pointsData.find(p => p.code_siep !== 'Sin código SIEP');
		if (firstValid) {
			onSelectEstablishment(firstValid);
		}
	}, [pointsData, selectedEstablishmentSiep, onSelectEstablishment]);

	const selectedEstablishmentId = useMemo(() => {
		const selectedSiep = selectedEstablishmentSiep != null
			? String(selectedEstablishmentSiep)
			: null;

		if (!selectedSiep) {
			return null;
		}

		return establishments.find(
			establishment => String(establishment.siep_code) === selectedSiep
		)?._id;
	}, [establishments, selectedEstablishmentSiep]);

	return (
		<React.Fragment>
			<MapMultiple
				title={title}
				points={pointsData}
				zoom={zoom}
				selectedEstablishmentId={selectedEstablishmentId}
				handleMarkerClick={handleMarkerClick}
				customMarker={customMarker}
			/>
		</React.Fragment>
	);
};

export { MapEstablishmentList };